import React from 'react'

const Lock = (props) => (
    <svg width="57" height="76" viewBox="0 0 57 76" fill={props.color ? props.color : '#1D79FB'}
         className={props.className ? props.className : ''} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M49.875 28.5H47.5V19C47.5 8.5215 38.9785 0 28.5 0C18.0215 0 9.5 8.5215 9.5 19V28.5H7.125C3.19833 28.5 0 31.6952 0 35.625V68.875C0 72.8048 3.19833 76 7.125 76H49.875C53.8017 76 57 72.8048 57 68.875V35.625C57 31.6952 53.8017 28.5 49.875 28.5ZM15.8333 19C15.8333 12.0143 21.5143 6.33333 28.5 6.33333C35.4857 6.33333 41.1667 12.0143 41.1667 19V28.5H15.8333V19ZM31.6667 52.953V60.1667C31.6667 61.9147 30.2512 63.3333 28.5 63.3333C26.7488 63.3333 25.3333 61.9147 25.3333 60.1667V52.953C23.4492 51.8542 22.1667 49.8338 22.1667 47.5C22.1667 44.0072 25.0072 41.1667 28.5 41.1667C31.9928 41.1667 34.8333 44.0072 34.8333 47.5C34.8333 49.8338 33.5508 51.8542 31.6667 52.953Z"
        />
    </svg>
)

export default Lock
